var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fanzone-form',{attrs:{"id":_vm.id,"redirectTo":"/#/fanzones","label":"Festiwale","idStepsEvent":true,"idsRelatedEvents":true,"scenesEditor":true}})}
var staticRenderFns = []

export { render, staticRenderFns }